import React from 'react';
import {useAuth0} from '@auth0/auth0-react';
import {useNavigate} from 'react-router-dom';
import {LoginLayout} from '../../Layouts/LoginLayout';
import {Auth0TokenData, Auth0TokenValidateRequest} from '../../Actions/Users/UsersDomain';
import {decodeAuth0Token} from '../../Actions/Users/UsersActions';
import {useParameterizedQuery} from 'react-fetching-library';
import {useAuthDispatch, useAuthState} from '../../Context/AuthProvider/AuthProvider';
import {addUserLogin} from '../../Context/AuthProvider/AuthProviderActions';
import {UserOutlined} from '@ant-design/icons';
import {EmptyState} from '../../Components/EmptyState';

export const Auth0Callback: React.FunctionComponent = (_props) => {
    const [validCompany, setValidCompany] = React.useState<string>('');
    const [action, setAction] = React.useState<string>('');
    const [auth0Token, setAuth0Token] = React.useState<Auth0TokenData>();

    const [message, setMessage] = React.useState<string>();

    const { isLoading, error, getAccessTokenSilently, getIdTokenClaims } = useAuth0();
    const navigate = useNavigate();

    const [initialized, setInitialized] = React.useState<boolean>(false);
    const decodeAuth0TokenAction =  useParameterizedQuery(decodeAuth0Token);

    const authData = useAuthState();
    const authDispatch = useAuthDispatch();

    const [errorMessage, setErrorMessage] = React.useState<string>();

    const loading = React.useMemo( () => {
        return isLoading || decodeAuth0TokenAction.loading || authData.loading;
    }, [authData.loading, decodeAuth0TokenAction.loading, isLoading] );

    React.useEffect(() => {
        if (error){
            setErrorMessage(error.message);
            setValidCompany('');
            return;
        }

        setMessage('Recibiendo información de Auth0');
        getAccessTokenSilently({ detailedResponse: true }).then(res => {
            setMessage(undefined);
            if (res === undefined || res === null) {
                setAuth0Token(undefined);
            } else {
                setAuth0Token(res as Auth0TokenData);
            }
        });

        const company = sessionStorage.getItem('company_tmp');
        if (company !== null) {
            setValidCompany(company);
        } else {
            setValidCompany('');
        }


        const actionTMP = sessionStorage.getItem('action_tmp');
        if (actionTMP !== null) {
            setAction(actionTMP);
        } else {
            setAction('');
        }

    }, [isLoading, error, getAccessTokenSilently, navigate, getIdTokenClaims]);

    React.useEffect(() => {
        if (validCompany === '' || action === '') {
            return;
        }

        if ( auth0Token === undefined ) {
            return;
        }

        sessionStorage.removeItem('company_tmp');
        sessionStorage.removeItem('action_tmp');

        const tokenDataRequest: Auth0TokenValidateRequest = {
            company: validCompany,
            ...auth0Token
        };

        if(!initialized){
            setMessage('Validando Token');
            setInitialized(true);
            decodeAuth0TokenAction.query(tokenDataRequest).then((res) => {
                setMessage(undefined);
                console.log(res);

                if (res.error) {
                    setErrorMessage('Existio un error al comunicarse con el servidor');
                    return;
                }

                const payload = res.payload;
                if (!(payload === undefined || payload === null)) {
                    if(payload.error['has-error'] && payload.error['error'] !== undefined){
                        setErrorMessage(payload.error['error']);
                        return;
                    }

                    sessionStorage.setItem('auth0-login', 'ok');
                    addUserLogin(payload, authDispatch).then();
                }
            });
        }
    }, [validCompany, action, navigate, auth0Token, decodeAuth0TokenAction, initialized, authDispatch]);

    const handleNavigate = React.useCallback( ()=>{
        switch (action) {
            case 'zendesk':
                navigate('/zendesk/sso');
                break;
            default:
                navigate('/');
                break;
        }
    }, [action, navigate] );

    React.useEffect(()=>{
        if( authData.token !== undefined && authData.token !== '' ){
            handleNavigate();
        }
    }, [authData.token, handleNavigate]);

    React.useEffect( ()=>{
        if ( errorMessage !== undefined && errorMessage !== null ){
            sessionStorage.setItem('error-message', errorMessage);
            handleNavigate();
        }
    }, [errorMessage, handleNavigate] );

    return (
        <LoginLayout loginTitle={''}>
            <EmptyState
                loading={ loading }
                icon={<UserOutlined />}
                message={(message !== null) ? message : 'Obteniendo información del Servidor'}
            />
        </LoginLayout>
    );
};
